import React, { useEffect, useState, useContext, useCallback, useMemo, useRef, memo, useLayoutEffect } from "react";
import { SessionContext } from '../context/sessionContext';
import {Link, useHistory, useLocation} from "react-router-dom";
import { Nav,  Navbar, NavDropdown, Container, Form, Button } from "react-bootstrap";

import Modal from 'react-bootstrap/Modal';
import ReactDOM from 'react-dom';

import ImageNav from '../marca_botonera-01.png';
import Login_form from "./login_form";
import Change_passw from "./change_passw";
import Change_agenda from "./change_agenda";

import { toast } from "react-toastify";

const ModalX = ({ isOpen, onClose, title, children }) => {

	const [isDragging, setIsDragging] = useState(false);
	const [initialX, setInitialX] = useState(0);
	const [initialY, setInitialY] = useState(0);
	const [offsetX, setOffsetX] = useState(0);
	const [offsetY, setOffsetY] = useState(0);
	const [isMinimizedX, setIsMinimized] = useState(false);
	//const [prevPosition, setPrevPosition] = useState({ x: 0, y: 0 });
	const [headerHeight, setHeaderHeight] = useState(0); // Estado para almacenar la altura del header
    const headerRef = useRef(null); // Referencia al elemento del header
	const modalRef = useRef(null);

	// Centrado inicial del modal
  useLayoutEffect(() => {
    if (isOpen && modalRef.current) {
      const modalWidth = modalRef.current.offsetWidth;
      const modalHeight = modalRef.current.offsetHeight;

	  // Calcular las posiciones iniciales para centrar el modal
      let calculatedOffsetY = (window.innerHeight - modalHeight) / 2;

      // Restar un valor para moverlo más arriba (ejemplo: 50px)
      calculatedOffsetY -= 80;

      // Calcular las posiciones iniciales para centrar el modal
      setOffsetX((window.innerWidth - modalWidth) / 2);
      //setOffsetY((window.innerHeight - modalHeight) / 2);
	  setOffsetY(calculatedOffsetY);
    }
  }, [isOpen]); // Solo recalcula cuando isOpen cambia

	useEffect(() => {
		if (isDragging) {
			window.addEventListener('mousemove', handleMouseMoveX);
			window.addEventListener('mouseup', handleMouseUpX);
		}

		return () => {
			window.removeEventListener('mousemove', handleMouseMoveX);
			window.removeEventListener('mouseup', handleMouseUpX);
		};
	}, [isDragging, initialX, initialY]);

	// Obtener la altura del header después de que se renderiza
	useEffect(() => {        
        if (headerRef.current) {
            setHeaderHeight(headerRef.current.offsetHeight);
        }
    }, [isMinimizedX]); // Se ejecuta solo una vez al montar el componente

	// Centrado inicial
	/*useEffect(() => {
		//if (isOpen && modalRef.current && offsetX === 0 && offsetY === 0) {
		if (isOpen && modalRef.current) {
			const modalWidth = modalRef.current.offsetWidth;
			const modalHeight = modalRef.current.offsetHeight;
			setOffsetX((window.innerWidth - modalWidth) / 2);
			setOffsetY((window.innerHeight - modalHeight) / 2);
		}
	}, [isOpen]);*/	

	const handleMouseDownX = (e) => {
		//console.log("UNO")
		if (e.target === e.currentTarget) {
		//if (headerRef.current.contains(e.target)) {
			//console.log("DOS")
			setIsDragging(true);
			setInitialX(e.clientX - offsetX);
			setInitialY(e.clientY - offsetY);
		}
	};

	const handleMouseMoveX = (e) => {
		//console.log("MOVING");
		if (isDragging) {
			const newX = e.clientX - initialX;
			const newY = e.clientY - initialY;

			//console.log("newX:", newX, "newY:", newY, "offsetX:", offsetX, "offsetY:", offsetY);

			// Limitar el movimiento dentro de la ventana
			const { innerWidth, innerHeight } = window;
			const modalWidth = modalRef.current.offsetWidth;
      		const modalHeight = modalRef.current.offsetHeight;

			const maxX = innerWidth - modalWidth; 
			const maxY = innerHeight - modalHeight; 

			//const maxX = innerWidth - e.currentTarget.offsetWidth; //NO HABÏA que hacer el calculo de los límites basados en las dimensiones de la ventana
			//const maxY = innerHeight - e.currentTarget.offsetHeight;

			setOffsetX(Math.max(0, Math.min(newX, maxX)));
			setOffsetY(Math.max(0, Math.min(newY, maxY)));
		}
	};

	const handleMouseUpX = () => {
		setIsDragging(false);
	};

	const toggleMinimize = () => {
		/*if (!isMinimizedX) {
			setPrevPosition({ x: offsetX, y: offsetY });
			//setOffsetY(window.innerHeight - 60); // Posición minimizada abajo
		} else {
			setOffsetX(prevPosition.x);
			setOffsetY(prevPosition.y);
		}*/
		setIsMinimized(!isMinimizedX);
	};	

	//NO USAR ----> no cerramos la ventana dando click fuera de la ventana, usar el buton en el header
	const handleOverlayClick = (e) => {
		if (e.target === e.currentTarget) {
			onClose();
		}
	};

	const getModalContentStyle = () => {
        const baseStyle = {
            backgroundColor: 'white',
			//width: '60vw',
            borderRadius: '8px',
            position: 'fixed',
            minWidth: '300px',
            //maxWidth: '600px',
			//maxWidth: '60vw',
			maxWidth: '80%', // Ejemplo de ancho máximo en porcentaje
        	width: '70%',     // Establece un ancho en porcentaje por defecto
			top: `${offsetY}px`,
      		left: `${offsetX}px`,
			//transform: `translate(${offsetX}px, ${offsetY}px)`,
      		transition: isDragging ? 'none' : 'transform 0.3s, height 0.3s',
			cursor: isDragging ? 'grabbing' : 'default',
            overflow: 'hidden',
            //...style
        };

        /*if (isMinimizedX && headerRef.current) {
			console.log("ALTURA", headerRef.current?.offsetHeight)
            return { ...baseStyle, height: `${headerRef.current.offsetHeight}px` };
        }*/

		// Si está minimizado, ajustar la altura del modal al header
		return isMinimizedX
			? { ...baseStyle, height: `${headerHeight}px` }
			: baseStyle;

        //return { ...baseStyle, height: 'auto' };
    };

	if (!isOpen) return null;

	return (
		<>
			{/* Overlay */}
			<div
				className="modal-overlay"
				//onClick={handleOverlayClick}
				style={{
					position: 'fixed',
					top: 0,
					right: 0,
					bottom: 0,
					left: 0,
					//backgroundColor: 'rgba(0, 0, 0, 0.5)',
					backgroundColor: isMinimizedX ? 'transparent' : 'rgba(0, 0, 0, 0.5)',
					pointerEvents: isMinimizedX ? 'none' : 'auto',
					
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					zIndex: 1000,
				}}
			>

				<div
					ref={modalRef} // Asignamos la ref aquí
					//className="modal-content"
					style={getModalContentStyle()}
					onClick={(e) => e.stopPropagation()}
				>
					{/* Header */}
					<div
						ref={headerRef}
						style={{
							display: 'flex',
							height: "60px",
							justifyContent: 'space-between',
							alignItems: 'center',
							padding: '16px 24px',
							borderBottom: '1px solid #e0e0e0',
							borderRadius: '8px 8px 0 0',
							//backgroundColor: '#f8f9fa',
							background: isMinimizedX ? "grey" : "rgb(0,174,195)",
							cursor: 'grab',
							pointerEvents: 'auto'
						}}
						onMouseDown={handleMouseDownX}
					>
						<h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 600 }}>
							{title}
						</h3>
						<div style={{ display: 'flex', gap: '10px' }}>

							<button
								onClick={toggleMinimize}
								style={{
									background: 'none',
									border: 'none',
									fontSize: '1.2rem',
									cursor: 'pointer',
									padding: '4px',
									color: '#666',
									'&:hover': { color: '#333' }
								}}
							>
								{isMinimizedX ? '↥' : '–'}
							</button>

							<button
								onClick={onClose}
								style={{
									background: 'none',
									border: 'none',
									fontSize: '1.5rem',
									cursor: 'pointer',
									padding: '4px',
									color: '#666',
									'&:hover': { color: '#333' }
								}}
							>
								&times;
							</button>
						</div>
					</div>

					{/* Body con minimizado */}
					<div
						style={{
							padding: isMinimizedX ? 0 : '24px',
							maxHeight: isMinimizedX ? 0 : '70vh',
							overflowY: 'auto',
							visibility: isMinimizedX ? 'hidden' : 'visible',
							opacity: isMinimizedX ? 0 : 1,
							transition: 'all 0.3s ease',
							opacity: isMinimizedX ? 0 : 1
						}}
					>
						{children}
					</div>
				</div>
			</div>
		</>
	);
};

const Navigation = ({ setAuth }) => { //name, role, setRole, //activo

	const { roleA, setRoleA, codValidez, usuario } = useContext(SessionContext);
	console.log("USARIO en CONTEXT", usuario)

	const [modals, setModals] = useState({ 
        changePass: false, 
        agenda: false, 
        login: false 
    });

	const [showChangePass, setShowChangePass] = useState(false);

	// Estados para mostrar el modal y minimizar
    const [showAgenda, setShowAgenda] = useState();
	console.log("SHOW AGENDA", showAgenda)
	
	const [isMinimized, setIsMinimized] = useState(false);
	console.log("MINIMIZADO ------>", isMinimized)

	//const [agendaComentario, setAgendaComentario] = useState(""); // Nuevo estado para el comentario
	//console.log("ESTADO COMENTARIO en el padre", agendaComentario)

	const [finalPosition, setFinalPosition] = useState({
		x: window.innerWidth * 0.2,
		y: window.innerHeight * 0.1
	});

	// Nuevo estado para controlar la visibilidad del contenido de la agenda
    //const [showAgendaContent, setShowAgendaContent] = useState(false);

	// Ref para el contenedor del contenido del modal
    const modalContentRef = useRef(null);

	// Refs para el estado de arrastre
	const isDraggingRef = useRef(false);
	const dragStartRef = useRef({ mouseX: 0, mouseY: 0, modalX: 0, modalY: 0 });
	const ghostModalRef = useRef(null);
  	const modalInstanceRef = useRef(null);

	// Nueva ref para el contenedor del portal
  //const portalRef = useRef(document.createElement('div'));

	// Usamos useRef para la posición para evitar rerenders durante el arrastre
	const positionRef = useRef({ x: window.innerWidth * 0.2, y: window.innerHeight * 0.1 });
	//const [position, setPosition] = useState(positionRef.current); // Solo para el render inicial

	const [position, setPosition] = useState({ 
		x: window.innerWidth * 0.2, 
		y: window.innerHeight * 0.1 
	  });

	// Refs para el modal y el header
    const modalRef = useRef(null);
    const headerRef = useRef(null);

    const [showLoginModal, setShowLoginModal] = useState(false);
	//const [show, setShow] = useState(false);
    const [agendaActivo, setAgendaActivo] = useState(false);

	const history = useHistory();
	const location = useLocation();
	
    const activo = location.pathname.split('/')[1] || 'inicio'; // Obtener ruta activa desde la ubicación
	console.log("RUTA ACTIVA", activo)

	//const loadComentarios = true;
	//const loadComentarios = useMemo(() => true, []); // Valor memoizado (no cambia)

	//const role = roleA.roleA; //original
	//const role = roleA?.roleA; //opcion 2, mas seguro si roleA es null o undefined
	
	//const username = roleA.username; //original
	//const username = roleA?.username; //opcion 2

	//REVISAR no funcionó (10abril25)
	//const { roleA, username } = roleA || { roleA: 'user', username: '' }; //destructuring con valor por defecto
	//Equivaldría a:
	const role = roleA?.roleA;
	const username = roleA?.username;

	const isAdmin = role === 'admin';
    const isEditor = role === 'editor';
	const isVisualizador = role === 'visualizador';
	const isUser = role === 'user';
    const isLoggedIn = username && username !== 'sesion expirada';

	//EX 18-09-2026: el rol 'user' no tenia rama en el render del menu, asi que esas cuentas se
	//logueaban a una navbar VACIA (sin forma de navegar salvo escribiendo la URL). Ahora ve el mismo
	//menu que el resto: los permisos se aplican igual (los botones de guardar estan deshabilitados
	//para 'user' y 'visualizador' en los formularios).
	//OJO con el isLoggedIn: la navbar se renderiza en TODAS las rutas, incluida /login, y el contexto
	//arranca con el default {roleA:"user", username:""}. Sin esta condicion, el rol 'user' del default
	//matchearia y el MENU APARECERIA SIN SESION INICIADA (antes no se veia justamente porque ningun
	//rol tenia rama). Con username vacio o "sesion expirada" el menu queda oculto.
	const puedeVerMenu = (isAdmin || isEditor || isVisualizador || isUser) && isLoggedIn;
	/*
	Crea un flag que es true solo si:
	1 - Existe un username
	2- El username no es "sesion expirada"
	*/
	const shouldChangePassword = codValidez === 0 || localStorage.validezT === '0';

	// Efecto para cambio de contraseña
	useEffect(()=>{ 
		if(shouldChangePassword){ //#PENDIENTE 29AGOS2023 //cambio 10abr25 --> codValidez === 0 || localStorage.validezT === 0
			//setShowChangePass(true)
			//setModals(prev => ({ ...prev, changePass: true })); //deep
			setShowChangePass(true); //gemini
		}
	}, [shouldChangePassword])
	
	
	const [original, setOriginal] = useState(0);



	//****NUEVA */	
	/*const handleAgendaComentarioChange = useCallback((newComentario) => {
        setAgendaComentario(newComentario);
    }, [setAgendaComentario]);*/





	const handleShowLoginModal = useCallback(() => setShowLoginModal(true), []);

	const handleCloseLoginModal = useCallback(() => setShowLoginModal(false), []);	
	
	const handleCloseChange = useCallback(() => { //handleCloseChangePass no es solo para cambio de pass, tambien es para cerrar modal agenda
        setShowChangePass(false);
        setShowAgenda(false);
        setAgendaActivo(false);
        setIsMinimized(false);
        //setAgendaComentario(""); // Limpiar el comentario al cerrar el modal
    }, [setShowChangePass, setShowAgenda, setAgendaActivo, setIsMinimized ]); //setAgendaComentario

	const handleMinimize = useCallback(() => setIsMinimized(prev => !prev), []);	

	// Manejador de mouseDown optimizado
	const handleMouseDown = useCallback((e) => {
		if (e.target.closest('button')) return;

		isDraggingRef.current = true;
		dragStartRef.current = {
			mouseX: e.clientX,
			mouseY: e.clientY,
			modalX: position.x,//finalPosition.x,
			modalY: position.y//finalPosition.y
		};
		
		// Creamos el fantasma solo si el modal existe
		if (modalRef.current) {
			const ghost = modalRef.current.cloneNode(true);
			ghost.style.position = 'fixed';
			ghost.style.zIndex = 9999;
			ghost.style.pointerEvents = 'none';
			ghost.style.opacity = '0.7';
			ghost.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.5)';
			ghost.style.left = `${position.x}px`;
			ghost.style.top = `${position.y}px`;
			document.body.appendChild(ghost);
			ghostModalRef.current = ghost;
			
			// Ocultamos el modal original durante el arrastre
			modalRef.current.style.visibility = 'hidden';
		  }

		e.preventDefault();
		e.stopPropagation();
	}, [position]); //finalPosition	

	//const handleShowAgendaModal = useCallback(() => setShowAgenda(true), []);
	const handleShowAgendaModal = useCallback(() => {
        setShowAgenda(true);
		setIsMinimized(false); // Asegurarse de que no esté minimizado al abrir
        //setShowAgendaContent(true); // Mostrar el contenido al abrir
    }, []);

	// Navigation functions using useCallback for memoization
    const navigate = useCallback((path) => history.push(path), [history]);
    const routeInicio = useCallback(() => navigate('inicio'), [navigate]);
    const routeExp = useCallback(() => navigate('expediente'), [navigate]);
	/*const handleInicioClick = useCallback(() => {
        navigate('/expediente', { state: { miParametro: 'valorDesdeMenu' } });
    }, [navigate]);*/
    const routeReportes = useCallback(() => navigate('tramitaciones'), [navigate]);
    const routeMapas = useCallback(() => navigate('mapas'), [navigate]);
    const routeGraficos = useCallback(() => navigate('graficos'), [navigate]);
    const routeInfPartido = useCallback(() => navigate('informes_partido'), [navigate]);

	// Condiciones de visibilidad
	const shouldShowAgenda = (isAdmin || isEditor) && isLoggedIn; //no disponible para isVisualizador
	const shouldShowChangePass = showChangePass && isLoggedIn;
	const shouldShowLogin = !isLoggedIn;

	const routeInicioDos = () =>{
		let path = `inicio_dos`;
		history.push(path);
	}
	
	// Logout function
    const logout = useCallback(async (e) => {
        e.preventDefault();
        try {
            localStorage.removeItem("tokenT");
            localStorage.removeItem("roleT");
            localStorage.removeItem("username");
            localStorage.removeItem("validezT");
            localStorage.removeItem("tokenActualizacion");
            setAuth(false);
            setRoleA({ roleA: "user", username: "" });
            
            setIsModalOpen(false); //cerrar la agenda si esta visible
            toast.success("Logout successfully");
        } catch (err) {
            console.error(err.message);
        }
    }, [setAuth, setRoleA]);
	
	// Login function
    const login = useCallback((e) => {
        e.preventDefault();
        handleShowLoginModal();
    }, [handleShowLoginModal]);
	
	// Navigate to Agenda
    const irAgenda = useCallback((e) => {
        e.preventDefault();
        setAgendaActivo("agenda");
        handleShowAgendaModal();
    }, [handleShowAgendaModal]);
	
	// Conditional rendering for buttons using useCallback
	const NavBtn = ({ active, onClick, children }) => (
		<button
			type="button"
			onClick={onClick}
			className={active
				? "px-4 py-2 rounded-md text-sm font-medium no-underline whitespace-nowrap transition-colors duration-200 bg-[rgb(50_85_155)] text-white"
				: "px-4 py-2 rounded-md text-sm font-medium no-underline whitespace-nowrap transition-colors duration-200 bg-[rgb(163_216_231)] text-[rgb(131_131_131)] hover:bg-gray-100"}
		>{children}</button>
	);

	const AuthButton = useCallback(() => (
		username !== 'sesion expirada'
			? (
				<button
					type="button"
					onClick={logout}
					className="px-3 py-2 text-sm font-semibold text-white bg-[#222] rounded-md hover:bg-[#333] transition-colors duration-200 whitespace-nowrap"
				>
					Logout
				</button>
			)
			: (
				<button
					type="button"
					onClick={login}
					className="px-4 py-2 rounded-md text-sm font-medium no-underline whitespace-nowrap transition-colors duration-200 bg-[rgb(163_216_231)] text-[rgb(131_131_131)] hover:bg-gray-100"
				>
					Login
				</button>
			)
	), [username, logout, login]);

	const InicioButton = useCallback(() => (
		<NavBtn active={activo === "inicio"} onClick={routeInicio}>Inicio</NavBtn>
	), [activo, routeInicio]);

	const inicioDosButton = () => (
		<NavBtn active={activo === "inicio_dos"} onClick={routeInicioDos}>Inicio Dos</NavBtn>
	);

	const NewExpButton = useCallback(() => (
		<NavBtn active={activo === "expediente"} onClick={routeExp}>Nuevo Expte</NavBtn>
	), [activo, routeExp]);

	const ReportesButton = useCallback(() => (
		<NavBtn active={activo === "tramitaciones"} onClick={routeReportes}>Tramitaciones</NavBtn>
	), [activo, routeReportes]);

	const MapasButton = useCallback(() => (
		<NavBtn active={activo === "mapas"} onClick={routeMapas}>Mapas e Informes</NavBtn>
	), [activo, routeMapas]);

	const GraficosButton = useCallback(() => (
		<NavBtn active={activo === "graficos"} onClick={routeGraficos}>Gráficos</NavBtn>
	), [activo, routeGraficos]);

	const InformesPartidoButton = useCallback(() => (
		<NavBtn active={activo === "informes_partido"} onClick={routeInfPartido}>Por Partido</NavBtn>
	), [activo, routeInfPartido]);

	const AgendaButton = useCallback(() => (
		<NavBtn active={agendaActivo === "agenda"} onClick={irAgenda}>Agenda (testeo)</NavBtn>
	), [agendaActivo, irAgenda]);

	const AgendaButtonDOS = () => (
		<NavBtn active={false} onClick={() => setIsModalOpen(true)}>Agenda</NavBtn>
	);


	const [hideBody, setHideBody] = useState(true);

	const [isModalOpen, setIsModalOpen] = useState(false);
	

	
	// Modals
	const ModalAgenda = useCallback(() => {
		return (
		  <Modal
			show={showAgenda}
			onHide={() => !isMinimized && handleCloseChange()}
			backdrop={isMinimized ? false :"static"}
			enforceFocus={false} // Permite foco en elementos externos
			keyboard={false}
			//style={{ display: showAgenda ? 'block' : 'none' }}
			className={`id_modal_2 ${isMinimized ? 'modal-minimized' : ''}`}
			style={{ 
				display: showAgenda ? 'block' : 'none',
				pointerEvents: isMinimized ? 'none' : 'auto' 
			}}
			dialogAs={React.forwardRef((props, ref) => (
			  <div
				//ref={ref}
					ref={(node) => {
						// Asignamos ambas refs: la de Modal y la nuestra
						if (typeof ref === 'function') ref(node);
						else if (ref) ref.current = node;
						modalRef.current = node;
					}}
				style={{
				  position: 'fixed',
				  left: `${position.x}px`,
				  top: `${position.y}px`,
				  width: '60vw',
				  //width: isMinimized ? 'auto' : '60vw', // Ajuste clave
				  height: isMinimized ? 'auto' : '80vh',
				  maxWidth: '60vw',
				  maxHeight: '80vh',
				  margin: 0,
				  zIndex: 1050,
				  transition: isDraggingRef.current ? 'none' : 'left 0.2s, top 0.2s',
				  //pointerEvents: 'auto'
				  pointerEvents: isMinimized ? 'none' : 'auto',
				  boxShadow: isMinimized ? 'none' : '0 10px 25px rgba(0,0,0,0.5)'
				}}
				onClick={(e) => e.stopPropagation()} // ← Evita propagación de clicks
				{...props}
			  >
				<div
				  ref={headerRef}
				  onMouseDown={handleMouseDown}
				  style={{
					background: isMinimized ? "grey" : "rgb(0,174,195)",
					color: "white",
					borderColor: isMinimized ? 'white' : 'rgb(0,174,195)', 
					cursor: isDraggingRef.current ? 'grabbing' : 'grab',
					display: 'flex',
					justifyContent: 'flex-start',
					alignItems: 'center',
					userSelect: 'none',
					padding: '1rem',
					borderTopLeftRadius: 'calc(0.3rem - 1px)',
					borderTopRightRadius: 'calc(0.3rem - 1px)',
					pointerEvents: 'auto' // Siempre interactivo
				  }}
				>
				  <div style={{ flexGrow: 1 }}>Agenda</div>
				  <div style={{ pointerEvents: 'auto' }}> 
					
					<button
					  type="button"
					  className="btn btn-sm btn-outline-light"
					  onClick={handleMinimize}
					  style={{ marginLeft: '10px' }}
					>
					  {isMinimized ? '+' : '-'}
					</button>
					<button
					  type="button"
					  className="btn-close btn-outline-light btn-close-white"
					  aria-label="Close"
					  onClick={handleCloseChange}
					/>
				  </div>
				</div>
				
				<div
					ref={modalContentRef}
					style={{
						padding: '1rem',
						backgroundColor: isMinimized ? 'cyan' : '#fff',
						borderBottomLeftRadius: 'calc(0.3rem - 1px)',
						borderBottomRightRadius: 'calc(0.3rem - 1px)',
						overflow: 'auto',
						height: 'calc(100% - 56px)',
						pointerEvents: 'auto',
						// Control de visibilidad del contenido
						//display: isMinimized ? 'none' : 'block'
						visibility: isMinimized ? 'hidden' : 'visible'
					}}
				>
                    {/* <Change_agenda loadComentarios={loadComentarios} /> */}
					<Change_agenda />
					
				</div>
			  </div>
			))}
		  />
		);
	  }, [showAgenda, position, isMinimized, handleCloseChange, handleMinimize, handleMouseDown ]);
	  //sacar de dependencias: loadComentarios 16-abril-2025
	 
	const ModalChangePassword = useCallback(() => (
        <Modal
            id="id_modal_F"
            show={showChangePass}
            onHide={handleCloseChange} //handleCloseChangePass
            backdrop="static"
            keyboard={false}
            className="id_modal_2"
            style={{ top: "200", height: "70%" }}
        >
            <Modal.Header style={{ background: "rgb(0,174,195)", color: "white" }} closeButton>
                <Modal.Title>Cambiar contraseña</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Change_passw showChangePass={showChangePass} setShowChangePass={setShowChangePass} />
            </Modal.Body>
            <Modal.Footer />
        </Modal>
    ), [showChangePass, handleCloseChange, setShowChangePass]); //handleCloseChangePass

	const ModalLogin = useCallback(() => (
        <Modal
            id="id_modal_1"
            show={showLoginModal}
            onHide={handleCloseLoginModal}
            backdrop="static"
            keyboard={false}
            className="id_modal_1"
            style={{ top: "200", height: "auto" }}
        >
            <Modal.Header style={{ background: "rgb(0,174,195)", color: "white" }} closeButton>
                <Modal.Title>Sesión {username === 'sesion expirada' ? 'finalizó' : 'expiró - Login'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Login_form show={showLoginModal} setShow={setShowLoginModal} />
            </Modal.Body>
            {username === 'sesion expirada' && (
                <Modal.Footer>
                    <Button className="btn btn-success btn-block button_verde">Aceptar</Button>
                    <Button className="btn btn-success btn-block button_verde">Cancelar</Button>
                </Modal.Footer>
            )}
        </Modal>
    ), [showLoginModal, handleCloseLoginModal, username, setShowLoginModal]);

	// Menu structures
	const MenuNav = useCallback(({ children }) => {
		const items = React.Children.toArray(children);
		return (
			<div className="flex gap-2 sm:gap-4 px-4 py-3 w-full items-center justify-between">
				<div className="flex items-center gap-3 shrink-0">
					<Link to="/inicio" className="flex items-center">
						<img src={ImageNav} alt="Logo" className="" />
					</Link>
				</div>

				<div className="flex items-center gap-2 sm:gap-5 min-w-0">
					{items.map((child, i) => (
						<React.Fragment key={i}>
							{child}
							{i < items.length - 1 && <div className="w-px h-8 bg-gray-300 mt-5" />}
						</React.Fragment>
					))}
				</div>

				<div className="flex items-center gap-2 sm:gap-4 shrink-0 ml-auto">
					{username && username !== 'sesion expirada' && (
						<span className="hidden lg:inline text-sm text-white whitespace-nowrap">
							Bienvenido, {username} ({role})
						</span>
					)}
					<AuthButton />
				</div>
			</div>
		);
	}, [username, role, AuthButton]);

	const ProjectManagementSection = useCallback(() => (
		<div className="flex flex-col gap-1">
			<span className="hidden sm:inline text-[11px] font-bold uppercase tracking-wider text-gray-700">Gestión de Proyectos</span>
			<div className="flex items-center">
				<InicioButton />
				<NewExpButton />
				<ReportesButton />
			</div>
		</div>
	), [InicioButton, NewExpButton, ReportesButton]);

	const ReportsSection = useCallback(() => (
		<div className="flex flex-col gap-1">
			<span className="hidden sm:inline text-[11px] font-bold uppercase tracking-wider text-gray-700">Reportes</span>
			<div className="flex items-center">
				<MapasButton />
				<GraficosButton />
				<InformesPartidoButton />
				{(isAdmin) && <AgendaButton />}
				{(isAdmin || isEditor) && <AgendaButtonDOS />}
			</div>
		</div>
	), [isAdmin, isEditor, MapasButton, GraficosButton, InformesPartidoButton, AgendaButton, AgendaButtonDOS]);

	//EX 18-09-2026: aca habia TRES funciones identicas (menuNav_Admin, menuNav_User_Edit y
	//menuNav_Visualizador): todas devolvian MenuNav con ProjectManagementSection + ReportsSection.
	//Lo unico que cambia por rol esta adentro de ReportsSection (los botones de Agenda: solo admin /
	//admin+editor), que ya estaba gateado ahi. Se unifican en una sola.
	//De paso: menuNav_Visualizador tenia las dependencias incompletas ([MenuNav, ReportsSection], le
	//faltaba ProjectManagementSection), inconsistencia que desaparece.
	const menuNav = useCallback(() => (
		<MenuNav>
			<ProjectManagementSection />
			<ReportsSection />
		</MenuNav>
	), [MenuNav, ProjectManagementSection, ReportsSection]);


	// Calcula posición inicial cuando se muestra el modal
	useEffect(() => {
		if (showAgenda) {
			const initialX = window.innerWidth * 0.2;
			const initialY = window.innerHeight * 0.1;
			setPosition({ x: initialX, y: initialY });
		}
	}, [showAgenda]);
	
	// Efecto para el arrastre
	useEffect(() => {

		const handleMouseMove = (e) => {
			//if (!isDraggingRef.current) return;
			if (!isDraggingRef.current || !ghostModalRef.current) return;

			const { mouseX, mouseY, modalX, modalY } = dragStartRef.current;
			const deltaX = e.clientX - mouseX;
			const deltaY = e.clientY - mouseY;

			// Mover el clon fantasma
			ghostModalRef.current.style.left = `${modalX + deltaX}px`;
			ghostModalRef.current.style.top = `${modalY + deltaY}px`;
		};

		
		const handleMouseUp = (e) => {
			if (!isDraggingRef.current) return;

			// Calculamos la nueva posición
			if (ghostModalRef.current) {
				const { mouseX, mouseY, modalX, modalY } = dragStartRef.current;
				const deltaX = e.clientX - mouseX;
				const deltaY = e.clientY - mouseY;

				setPosition({
					x: modalX + deltaX,
					y: modalY + deltaY
				});

				// Eliminamos el fantasma
				document.body.removeChild(ghostModalRef.current);
				ghostModalRef.current = null;
			}

			// Mostramos el modal original
			if (modalRef.current) {
				modalRef.current.style.visibility = 'visible';
			}

			isDraggingRef.current = false;			
		};

		document.addEventListener('mousemove', handleMouseMove);
		document.addEventListener('mouseup', handleMouseUp);

		return () => {
			document.removeEventListener('mousemove', handleMouseMove);
			document.removeEventListener('mouseup', handleMouseUp);

			// Limpieza del fantasma si existe
			if (ghostModalRef.current) {
				document.body.removeChild(ghostModalRef.current);
			}
		};
	}, []);

	// Efecto para manejar la interacción cuando está minimizado
	useEffect(() => {
		if (!modalRef.current) return;

		if (isMinimized) {
			// Deshabilitar pointer-events en el modal excepto en el header
			modalRef.current.style.pointerEvents = 'none';
			const header = modalRef.current.querySelector('.modal-header');
			if (header) {
				header.style.pointerEvents = 'auto';
			}
		} else {
			// Restaurar pointer-events
			modalRef.current.style.pointerEvents = 'auto';
		}
	}, [isMinimized]);

	useEffect(()=>{

		if(codValidez===0){
			setShowChangePass(true)
		}
	}, [activo]) //cada vez que cambie el path

	return (
		<>
			<div>
				<header className="w-full sticky top-0 z-50 bg-custom-cyan transition-colors duration-200">
					{puedeVerMenu && menuNav()}
				</header>
				<ModalX
					isOpen={isModalOpen}
					onClose={() => setIsModalOpen(false)}
					title="Agenda (versión de desarrollo)"
				>
					<Change_agenda />
				</ModalX>
			</div>									
			
			{/*shouldShowAgenda && <ModalAgenda /> */}
			{shouldShowAgenda && ReactDOM.createPortal(
				ModalAgenda(),
				document.body
			)}
			{shouldShowChangePass && <ModalChangePassword />}
			{shouldShowLogin && <ModalLogin />}
		</>
	);	

};

export default Navigation;
